import { ApplicationRef, createComponent, Injectable, EnvironmentInjector } from '@angular/core';
import { UnauthorizedPopupComponent } from '../components/unauthorized.component';


@Injectable({ providedIn: 'root' })
export class UnauthorizedNotificationService {
  constructor(
    private appRef: ApplicationRef,
    private environmentInjector: EnvironmentInjector
  ) {}

  /**
   * Displays an unauthorized popup with an optional error URL.
   * @param errorUrl - The URL that caused the unauthorized access, if available.
   */
  showUnauthorized(errorUrl?: string) {
    // Create the component dynamically
    const componentRef = createComponent(UnauthorizedPopupComponent, { environmentInjector: this.environmentInjector });
    
    // Pass the errorUrl to the popup component
    if (errorUrl) {
      componentRef.instance.errorUrl = errorUrl;
    }

    // Attach to the appRef so it's part of the change detection
    this.appRef.attachView(componentRef.hostView);

    // Add to the DOM
    const domElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    
    // Optionally, handle closing the popup and cleanup
    componentRef.instance.close.subscribe(() => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    });
  }
}
